import { CreateFoodStockFoodListDTO } from '../models/FoodStockFood'
import { FoodStockRepository } from '../repositories/FoodStockRepository'

export function CreateFoodStockFoodCase(
  foodStockRepository: FoodStockRepository
) {
  return async function (data: CreateFoodStockFoodListDTO[]) {
    return await foodStockRepository.createFoodStockFood(data)
  }
}
